/**
 * Dispatched by surfaces outside the canvas context — the file detail pane's
 * Expand button — to open a block node full-size in the canvas lightbox.
 * In-context callers (the node toolbar and menu, the Enter key) call
 * `canvas.expandNode` directly.
 */
export const CANVAS_EXPAND_NODE_EVENT = "canvas:expand-node";

export interface CanvasExpandNodeDetail {
  nodeId: string;
}

/**
 * Ask the mounted canvas to expand `nodeId`. Returns true only if a canvas
 * handled it: the event is cancelable and the canvas handler calls
 * preventDefault() once it has expanded, so `false` covers both "no canvas is
 * mounted here" and "that node is not on this canvas".
 */
export function emitCanvasExpandNode(nodeId: string): boolean {
  if (!nodeId) return false;
  const event = new CustomEvent(CANVAS_EXPAND_NODE_EVENT, {
    detail: { nodeId } satisfies CanvasExpandNodeDetail,
    cancelable: true,
  });
  // dispatchEvent returns false when a listener called preventDefault().
  return !window.dispatchEvent(event);
}
